/* eslint-disable jsx-a11y/anchor-is-valid,@typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import TextPanel from "./TextPanel";
import ImagePanel from "./ImagePanel";
import { User } from "~/common/Store/models/User";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";
import PricePanel from "~/CustomizableToolPage/CustomizableTool/MainWindow/CustomizationControls/PricePanel";

interface Props {
  user: User;
  openModal: () => void;
  isTrs: boolean;
  toggleNavigationSidebar: () => void;
}

const CustomizationControls = ({
  user,
  openModal,
  toggleNavigationSidebar,
  isTrs,
}: Props) => {
  const [comments, setComments] = useState<string>("");

  const {
    itemStartingPrice,
    // @ts-ignore
    currentNavigationKey: { currentNavigationKeyType },
    // @ts-ignore
    changeNavigationKey,
    // @ts-ignore
    getNavigationKeyData,
    // @ts-ignore
    getIsPricingAvailable,
  } = useCustomizableContext();
  const handleNavigateToPricing = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const [key] = Object.entries(getNavigationKeyData()).find(
      // @ts-ignore
      ([, value]) => value.optionName === "pricing",
    ) || [2];
    changeNavigationKey({
      currentNavigationKey: Number(key),
      currentNavigationKeyType: "pricing",
    });
    e.preventDefault();
  };
  const isPricingAvailable = getIsPricingAvailable();

  return (
    (currentNavigationKeyType && (
      <div id="customization-controls" className="customize__box-main">
        {["image", "text"].includes(currentNavigationKeyType) ? (
          <>
            <div className="customize__img-btn">
              <p>
                <span className="starting-text">
                  Customized Prices Starting at&nbsp;
                  <span className="price">
                    {formatAsCurrency.formatIfUndefined(itemStartingPrice)}
                  </span>
                </span>
                <br />
                To get pricing, please upload an image file and make selections
              </p>
              {!!isPricingAvailable && (
                <a
                  href="#"
                  className="btn btn-primary"
                  onClick={(e) => handleNavigateToPricing(e)}
                >
                  Get Pricing
                </a>
              )}
            </div>
            {(currentNavigationKeyType === "image" && (
              <ImagePanel
                user={user}
                toggleNavigationSidebar={toggleNavigationSidebar}
              />
            )) || (
              <TextPanel
                user={user}
                toggleNavigationSidebar={toggleNavigationSidebar}
              />
            )}
          </>
        ) : (
          <PricePanel
            openModal={openModal}
            loadingCart={false}
            user={user}
            isTrs={isTrs}
            toggleNavigationSidebar={toggleNavigationSidebar}
            comments={comments}
            setComments={setComments}
          />
        )}
      </div>
    )) ||
    null
  );
};

export default CustomizationControls;
